import React from "react";
import { useSelector } from "react-redux";
import { IoMdClose } from "react-icons/io";
import {
  getNameInitials,
  formatMobileNumber,
} from "../../Utils/HelperFunctions";
import { Imagekit } from "../../Pages/CommonPages/ImageKit";

const Username = ({
  loggedIn,
  name,
  number,
  onClose,
  logo,
  storeName,
  subline,
}) => {
  const brandName = storeName || "The Crafts Archive";
  // Dial code from the resolved region (for a logged-in user this reflects
  // their account country, §1) — don't hardcode +91 for international users.
  const dialCode = useSelector((s) => s.location?.dialCode) || "91";
  return (
    <div className="flex justify-between items-center px-[16px] pt-[16px] pb-[14px]">
      <div className="flex gap-3 items-center min-w-0">
        <div className="w-[48px] h-[48px] rounded-full flex-none grid place-items-center font-[500] text-[17px] leading-none text-white bg-[#1B1E33] overflow-hidden">
          {loggedIn ? (
            getNameInitials({ name: name || "" })
          ) : logo ? (
            <Imagekit
              IMGName={logo}
              alt={brandName}
              lqip={false}
              className="w-full h-full object-cover block"
            />
          ) : (
            getNameInitials({ name: brandName })
          )}
        </div>
        <div className="min-w-0">
          <div className="text-[17px] font-[500] tracking-[-0.01em] leading-[1.1] text-[#1F212E] truncate">
            {loggedIn ? name?.trim() || "Welcome" : brandName}
          </div>
          <div className="text-[13px] text-[#545454] mt-[2px] truncate">
            {loggedIn ? `+${dialCode} ${formatMobileNumber(number)}` : subline}
          </div>
        </div>
      </div>
      <IoMdClose
        onClick={onClose}
        className="w-[34px] h-[34px] flex-none p-[7px] text-[#545454] cursor-pointer"
      />
    </div>
  );
};
export default Username;
